import { AlertComponent } from './alert.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [SharedModule, AlertComponent],
  exports: [AlertComponent],
})
export class AlertModule {}
